<template>
<div>
    <!-- ============================================================== -->
    <!-- Left Sidebar - style you can find in sidebar.scss  -->
    <!-- ============================================================== -->
    <aside class="left-sidebar">
        <!-- Sidebar scroll-->
        <div class="scroll-sidebar">
            <!-- Sidebar navigation-->
            <nav class="sidebar-nav">
                <ul id="sidebarnav" v-if="isAuthenticated">
                    <li v-permissions="'fm.releases.update|fm.customers.read|fm.priceagreements.read|fm.report.read'" @click="onClickOtherThanSupportItem()">
                        <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false">
                            <i class="mdi mdi-file-document"></i>
                            <span class="hide-menu">{{$t('sidebar.fmbeheer')}}</span>
                        </a>
                        <ul aria-expanded="false" class="collapse">
                            <li v-permissions="'fm.releases.update'">
                                <router-link :to="{ name: 'releases:index' }" class="waves-effect waves-dark" aria-expanded="false">{{$t('sidebar.releasesbeheren')}}</router-link>
                            </li>
                            <li v-permissions="'fm.customers.read'">
                                <router-link :to="{ name: 'customers:index' }" class="waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.klanten')}}
                                </router-link>
                            </li>
                            <li v-permissions="'fm.priceagreements.read'">
                                <router-link :to="{ name: 'price-agreements:index' }" class="waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.prijsafspraken')}}
                                </router-link>
                            </li>
                            <li v-permissions="'fm.report.read'">
                                <router-link :to="{ name: 'report:index' }" class="waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.rapportage')}}
                                </router-link>
                            </li>
                             
                        </ul>
                    </li>
                    <li v-permissions="'fm.releases.update|fm.customers.read|fm.priceagreements.read|fm.report.read'">
                        <a class="dashboard has-arrow waves-effect waves-dark" href="#" aria-expanded="false">
                            <i class="mdi mdi-help"></i>
                            <span class="hide-menu" v-permissions="'fmmodule.dashboard.read.user'">
                                <router-link id="supportLink" :to="{ name: 'dashboard:index' }" class="pl-0 waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.support')}}
                                </router-link>
                            </span>
                        </a>
                        <ul aria-expanded="false" class="collapse">
                            <li v-permissions="'fmmodule.invoicerecognitiondata.read.user'" @click="onClickSupportChild()">
                                <router-link :to="{ name: 'invoicerecognitiondata:index' }" class="waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.factuurherkenning')}}
                                </router-link>
                            </li>
                             <li v-permissions="'fmmanagement.documents.read.user'" @click="onClickSupportChild()">
                                <router-link :to="{ name: 'documents:index' }" class="waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.onbekendedocumenten')}}
                                </router-link>
                            </li>
                            <li v-permissions="'fmmodule.triggers.read'" @click="onClickSupportChild()">
                                <router-link :to="{ name: 'triggers:index' }" class="waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.triggers')}}
                                </router-link>
                            </li>
                            <li v-permissions="'fmmodule.mltriggers.read'" @click="onClickSupportChild()">
                                <router-link :to="{ name: 'mltriggers:index' }" class="waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.mltriggers')}}
                                </router-link>
                            </li>
                            <li v-permissions="'fmmodule.triggermeldingen.read.user'" @click="onClickSupportChild()">
                                <router-link :to="{ name: 'triggermeldingen:index' }" class="waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.triggermeldingen')}}
                                </router-link>
                            </li>
                            <li v-permissions="'fmmodule.feedback.read'" @click="onClickSupportChild()">
                                <router-link :to="{ name: 'feedback:index' }" class="waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.feedback')}}
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-permissions="'core.companies.read.system|core.groups.read.system|core.modules.read.system'" @click="onClickOtherThanSupportItem()">
                        <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false">
                            <i class="mdi mdi-lock-outline"></i>
                            <span class="hide-menu">{{$t('sidebar.beheren')}}</span>
                        </a>
                        <ul aria-expanded="false" class="collapse">
                            <li v-permissions="'core.companies.read.system'">
                                <router-link :to="{ name: 'companies:index' }" class="waves-effect waves-dark" aria-expanded="false">{{$t('sidebar.bedrijven')}}</router-link>
                            </li>
                            <li v-permissions="'core.groups.read.system'">
                                <router-link :to="{ name: 'groups:index' }" class="waves-effect waves-dark" aria-expanded="false">{{$t('sidebar.groepen')}}</router-link>
                            </li>
                            <li v-permissions="'core.modules.read.system'">
                                <router-link :to="{ name: 'modules:index' }" class="waves-effect waves-dark" aria-expanded="false">{{$t('sidebar.modules')}}</router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>
            <!-- End Sidebar navigation -->
        </div>
        <!-- End Sidebar scroll-->
    </aside>
    <!-- ============================================================== -->
    <!-- End Left Sidebar - style you can find in sidebar.scss  -->
    <!-- ============================================================== -->
</div>
</template>

<script>
import $ from "jquery";
import { productInfo } from '@/mixins/productInfo'

require('@/../public/js/sidebarmenu');

export default {
    mixins: [productInfo],	
    name: "SideBar",
    methods: {
        async handleLoginEvent(data) {
            this.isAuthenticated = data.loggedIn;
            this.profile = data.profile;

            if (this.isAuthenticated) {
                await this.$nextTick();
                $("#sidebarnav").AdminMenu();
            }
        },
        onClickSupportChild() {
            $("#supportLink").toggleClass('active');
        },
        onClickOtherThanSupportItem() {
            $("#supportLink").removeClass('active');
        }
    },  
    data() {
        return {
            isAuthenticated: false,
            profile: {}
        };
    }
};
</script>
<style>
    .dashboard {
        display: flex !important;
    }

    @media (min-width: 768px) {
        :is(.dashbard .mini-sidebar .sidebar-nav #sidebarnav > li > a) {
            padding: 12px 24px !important;
            width: 70px;
        }
    }    
</style>